import { PbhRequestOrderFileRelationModel } from "./PbhRequestOrderFileRelationModel";
import { PbhRequestRemark } from "./PbhRequestRemarkModel";

export class PbhRequestOrderModel {
  public ContractId?: number;
  public MelCategory?: string;
  public PreDefinedComponentId?: number;
  public Pn?: string;
  public PnDescription?: string;
  public AtaChapter?: number;
  public AircraftId?: number;
  public AirportCode?: string;
  public ReleaseType?: string;
  public CustomerPo?: string;
  public CustomerPoLine?: string;
  public DefectReason?: string;
  public MelDueDate?: string;
  public AttentionName?: string;
  public AttentionPhone?: string;
  public ConsigneeName?: string;
  public ConsigneeAddress?: string;
  public Email?: string;
  public ShippingAddress?: string;
  public OffWing?: boolean;
  public RequirementCategory?: number;
  public RequirementCategoryText?: string;
  public CustomerCode?: string;
  public AcRegistration?: string;
  public UnserviceablePn?: string;
  public UnserviceableSn?: string;
  public AdvancedXo?: string;
  public PnDifferenceRemark?: string;
  public HomeBaseRemark?: string;
  public UsedSn?: string;
  public RequestedDeliveryDate?: Date;
  public File?: PbhRequestOrderFileRelationModel;
  public ComponentType?: number | null;
  public Quantity?: number | null;
  public SsmType?: number | null;
  public RequestRemark?: PbhRequestRemark;
  public IsLocalRepair?: boolean;
}
